import { format } from 'date-fns';
import {
  EventNameDisplay,
  VenueNameDisplay,
} from 'src/components/Events/EventInfo';
import { BoostSolidIconDisplay } from 'src/components/SponsoredListings';
import { Content, useContent } from 'src/contexts/ContentContext';
import { useEventMetrics } from 'src/contexts/EventMetricsContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { RotatingWrapper } from 'src/core/ui/AnimatingWrapper';
import { useGetEventFullInfo } from 'src/hooks/useGetEventFullInfo';
import {
  PaperTicketOutlineIcon,
  ProcessingIcon,
  UnHideIcon,
} from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { Event, ListingMetrics, TopLevelCategory } from 'src/WebApiController';

import * as styles from './CampaignModal.css';

export const CampaignModalHeader = ({
  event,
  eventNameDisplay,
  metrics,
}: {
  event: Event;
  eventNameDisplay: string;
  metrics?: ListingMetrics;
}) => {
  const { venue } = useGetEventFullInfo(event);
  const { websiteMetrics } = useEventMetrics();

  const eventDate =
    event.dates.start && format(new Date(event.dates.start), 'MMM d @ h:mm a');
  const boostText = useContent(ContentId.Boost);

  return (
    <Stack
      direction="column"
      alignItems="center"
      gap="l"
      width="full"
      className={styles.boostHeaderContainer}
    >
      <BoostSolidIconDisplay size="48px" />
      <EventNameDisplay
        eventName={`${boostText}: ${eventNameDisplay}`}
        boldSubName={event.genre === TopLevelCategory.Sports}
        className={styles.boostHeaderText}
      />
      <Stack direction="column" alignItems="center" gap="m" width="full">
        <Stack gap="m" alignItems="center" justifyContent="center" width="full">
          <span className={styles.eventDateText}>{eventDate}</span>
          <span style={{ color: vars.color.borderSecondary }}>|</span>
          <VenueNameDisplay
            venueName={venue?.name}
            hideIcon
            className={styles.venueNameDisplayContainer}
            displayClassName={styles.venueNameDisplay}
          />
        </Stack>
        <Stack gap="l" alignItems="center">
          {websiteMetrics.isLoading ? (
            <RotatingWrapper>
              <ProcessingIcon size={vars.iconSize.l} />
            </RotatingWrapper>
          ) : (
            <>
              {!!metrics?.unsoldQty && (
                <Stack
                  gap="s"
                  alignItems="center"
                  className={styles.eventInfoContainer}
                >
                  <PaperTicketOutlineIcon
                    size={vars.iconSize.m}
                    fill={vars.color.iconPrimary}
                  />{' '}
                  <span>{metrics.unsoldQty}</span>
                  <Content id={ContentId.TicketsAvailable} />
                </Stack>
              )}
              {!!websiteMetrics.metrics?.eventVisitors?.currentValue && (
                <Stack
                  gap="s"
                  alignItems="center"
                  className={styles.eventInfoContainer}
                >
                  <UnHideIcon fill={vars.color.iconPrimary} />
                  <span>
                    {websiteMetrics.metrics?.eventVisitors?.currentValue}
                  </span>
                  <Content id={ContentId.PeopleViewing} />
                </Stack>
              )}
            </>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
